import React, { useState, useEffect } from "react";
import CommonDataTable from "./CommonDataTable";
import {
  PrimaryButton,
  Checkbox,
  TextField,
  IconButton,
  TooltipHost,
} from "@fluentui/react";
import { processAndUpdateToken } from "../Services/CommonFunctions";
import axios from "axios";
import { useRef } from "react";
import { baseUrl } from "../Services/Constants";
import DropdownComponent from "../Components/CommonComponents/DropDownComponent";
import { GetBrokerList } from "../Services/QuoteCompareService";
import { Sync20Regular, People20Regular } from "@fluentui/react-icons";
import { SimpleSnackbar } from "./SnackBar";

const ProposalClientSync = () => {
  const container = useRef();
  const [options, setOptions] = useState([]);
  const [brokerId, setBrokerId] = useState(null);
  const [jobInstance, setJobInstance] = useState([]);
  const [editableRows, setEditableRows] = useState({});
  const [clientSearch, setClientSearch] = useState("");
  const [jobCodeSearch, setJobCodeSearch] = useState("");
  const [allData, setAllData] = useState([]);

 const handleCheckboxChange = (checked, jobCode) => {
  setEditableRows((prev) => ({
    ...prev,
    [jobCode]: checked,
  }));
};

  const handleClientNameChange = (value, jobCode) => {
  const updatedRows = jobInstance.map((item) => {
    if (item.JobCode === jobCode) {
      return {
        ...item,
        ClientName: value || "",
      };
    }

    return item;
  });

  setJobInstance(updatedRows);
};

  const column = [
    {
  name: "",
  width: "60px",

  cell: (row) => (
    <Checkbox
      checked={editableRows[row.JobCode] || false}
      onChange={(e, checked) =>
        handleCheckboxChange(checked, row.JobCode)
      }
      styles={{
        checkbox: {
          transform: "scale(0.65)",
        },
      }}
    />
  ),
},

    {
  name: "Client Name",
  sortable: true,
  wrap: true,

  cell: (row, index) =>
    editableRows[row.JobCode] ? (
      <TextField
        value={row.ClientName || ""}
        onChange={(e, value) =>
          handleClientNameChange(value, row.JobCode)
        }
      />
    ) : (
      <span>{row.ClientName}</span>
    ),
},

    {
      name: "LOB Name",
      selector: (row) => row.LobName,
      sortable: true,
      wrap: true,

      style: {
        fontSize: "12px",
      },
    },

    {
      name: "Job Code",
      selector: (row) => row.JobCode,
      sortable: true,
      wrap: true,

      style: {
        fontSize: "12px",
      },
    },

   {
  name: "Action",
  width: "100px",

  cell: (row, index) => (
    <div
      style={{
        width: "100%",
        display: "flex",
        // justifyContent: "center",
        paddingLeft: "12px",
        alignItems: "center",
      }}
    >
      <TooltipHost content="Sync">
        <IconButton
          iconProps={{
            iconName: "Sync",
          }}
          styles={{
            root: {
              backgroundColor: "#0078d4",
              color: "#fff",
              width: "34px",
              height: "34px",
              borderRadius: "4px",
            },

            rootHovered: {
              backgroundColor: "#106ebe",
              color: "#fff",
            },
          }}
          onClick={() => handleSync(row, index)}
        />
      </TooltipHost>
    </div>
  ),
}
  ];

  useEffect(() => {
    const fetchBrokerList = async () => {
      try {
        document.body.classList.add("loading-indicator");

        const brokerList = await GetBrokerList();

        if (brokerList && brokerList.length > 0) {
          const dropDownData = brokerList.map((e) => ({
            key: e?.BrokerId,
            text: e?.VchBrokerName,
          }));

          setOptions(dropDownData);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.error("Error fetching broker list:", error);
        setOptions([]);
      } finally {
        document.body.classList.remove("loading-indicator");
      }
    };

    fetchBrokerList();
  }, []);

  const handleSync = async (row, index) => {
    try {
      let token = sessionStorage.getItem("token");

      document.body.classList.add("loading-indicator");

      token = await processAndUpdateToken(token);

      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const payload = {
        brokerId: brokerId,
        jobCode: row.JobCode,
        clientName: row.ClientName,
      };

      const response = await axios.post(
        `${baseUrl}/api/ProposalBuilder/UpdateClientName/UpdateClientName`,
        payload,
        { headers },
      );

      if (response?.status === 200) {
        container?.current?.showSnackbar(
          response?.data?.Message,
          "success",
          true
        );
      }
    } catch (error) {
      console.log(error);

      container?.current?.showSnackbar(
        "Failed to update client name",
        "error",
        true
      );
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  const getData = async () => {
    if (!brokerId) {
      alert("Please select broker");
      return;
    }

    let token = sessionStorage.getItem("token");

    document.body.classList.add("loading-indicator");

    token = await processAndUpdateToken(token);

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.get(
        `${baseUrl}/api/ProposalBuilder/GetCompletedJobCodes/GetAllClientForSync`,
        {
          headers,
          params: {
            brokerId: brokerId,
          },
        },
      );

      if (response?.status === 200) {
        const records = response?.data || [];

        // SORT BY Client NAME
        const filteredRecords = records
          .filter(
            (item) =>
              item?.ClientName &&
              item.ClientName.trim() !== "",
          )
          .sort((a, b) =>
            (a?.ClientName || "").localeCompare(
              b?.ClientName || "",
            ),
          );

        setAllData(filteredRecords);
        setJobInstance(filteredRecords);
      } else {
        setJobInstance([]);
      }
    } catch (error) {
      console.log(error);
      setJobInstance([]);
    } finally {
      document.body.classList.remove("loading-indicator");
    }
  };

  const handleDropdownChange = (event, option) => {
    setBrokerId(option?.key);
  };

  return (
    <div
      style={{
        width: "100%",
        marginTop: "5px",
        marginLeft: "5px",
        paddingRight: "20px",
      }}
    >
      {/* TOP SECTION */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
          paddingRight: "20px",
          gap: "15px",
        }}
      >
        {/* LEFT SIDE */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flexWrap: "wrap",
          }}
        >
          {/* Broker Dropdown */}
          <div style={{ width: "280px" }}>
            <DropdownComponent
              key={"drop_1"}
              options={options}
              selectedKey={brokerId}
              onChange={handleDropdownChange}
              placeholder="Select Broker"
            />
          </div>

          {/* Client Name Search */}
          <TextField
            placeholder="Search Client Name"
            styles={{
              root: {
                width: "220px",
                marginLeft: "10px",
              },
            }}
            value={clientSearch}
          onChange={(e, value) => {
        const searchValue = value || "";

        setClientSearch(searchValue);

        let filteredRecords = [...allData];

        // CLIENT NAME FILTER
        if (searchValue.trim() !== "") {
          filteredRecords = filteredRecords.filter((item) =>
            item.ClientName?.toLowerCase().includes(
              searchValue.toLowerCase(),
            ),
          );
        }

        // JOB CODE FILTER
        if (jobCodeSearch.trim() !== "") {
          filteredRecords = filteredRecords.filter((item) =>
            item.JobCode?.toLowerCase().includes(
              jobCodeSearch.toLowerCase(),
            ),
          );
        }

        setJobInstance(filteredRecords);
      }}
    />

    {/* Job Code Search */}
    <TextField
      placeholder="Search Job Code"
      value={jobCodeSearch}
      onChange={(e, value) => {
        const searchValue = value || "";

        setJobCodeSearch(searchValue);

        let filteredRecords = [...allData];

        // CLIENT NAME FILTER
        if (clientSearch.trim() !== "") {
          filteredRecords = filteredRecords.filter((item) =>
            item.ClientName?.toLowerCase().includes(
              clientSearch.toLowerCase(),
            ),
          );
        }

        // JOB CODE FILTER
        if (searchValue.trim() !== "") {
          filteredRecords = filteredRecords.filter((item) =>
            item.JobCode?.toLowerCase().includes(
              searchValue.toLowerCase(),
            ),
          );
        }

        setJobInstance(filteredRecords);
      }}
      styles={{
        root: {
          width: "220px",
        },
      }}
    />
  </div>

  {/* RIGHT SIDE BUTTON */}
  <TooltipHost content="Get Clients">
    <IconButton
      iconProps={{
        iconName: "People",
      }}
      styles={{
        root: {
          backgroundColor: "#0078d4",
          color: "#fff",
          width: "40px",
          height: "40px",
          borderRadius: "4px",
          marginRight: "10px",
        },

        rootHovered: {
          backgroundColor: "#106ebe",
          color: "#fff",
        },
      }}
      onClick={getData}
    />
  </TooltipHost>
</div>

      <div>
        <CommonDataTable column={column} data={jobInstance} />
      </div>
      <SimpleSnackbar ref={container} />
    </div>
  );
};

export default ProposalClientSync;